import React from 'react';
import { Facebook, Instagram, Music2, MessageCircle, Send, Twitter, AtSign } from 'lucide-react';
import './PlatformSidebar.css';

interface Platform {
  id: string;
  name: string;
  icon: React.ReactNode;
  count: number;
}

interface PlatformSidebarProps {
  activePlatform: string;
  onPlatformSelect: (platform: string) => void;
  platformCounts: { facebook: number; instagram: number; tiktok: number; zalo: number; threads: number };
}

export const PlatformSidebar: React.FC<PlatformSidebarProps> = ({
  activePlatform,
  onPlatformSelect,
  platformCounts
}) => {
  const platforms: Platform[] = [
    { 
      id: 'facebook', 
      name: 'Facebook', 
      icon: <Facebook size={24} />,
      count: platformCounts.facebook 
    },
    { 
      id: 'instagram', 
      name: 'Instagram', 
      icon: <Instagram size={24} />,
      count: platformCounts.instagram 
    },
    { 
      id: 'threads', 
      name: 'Threads', 
      icon: <AtSign size={24} />,
      count: platformCounts.threads 
    },
    { 
      id: 'tiktok', 
      name: 'TikTok', 
      icon: <Music2 size={24} />,
      count: platformCounts.tiktok 
    },
    { 
      id: 'zalo', 
      name: 'Zalo', 
      icon: <MessageCircle size={24} />,
      count: platformCounts.zalo
    },
    { 
      id: 'telegram', 
      name: 'Telegram', 
      icon: <Send size={24} />,
      count: 0
    },
    { 
      id: 'twitter', 
      name: 'X (Twitter)', 
      icon: <Twitter size={24} />,
      count: 0
    },
    { 
      id: 'reddit', 
      name: 'Reddit', 
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <circle cx="8.5" cy="10.5" r="1.5"/>
          <circle cx="15.5" cy="10.5" r="1.5"/>
          <path d="M8 15c1 1 3 1.5 4 1.5s3-.5 4-1.5"/>
        </svg>
      ),
      count: 0
    },
  ];

  return (
    <div className="platform-sidebar">
      {platforms.map((platform) => (
        <button
          key={platform.id}
          className={`platform-icon ${activePlatform === platform.id ? 'active' : ''}`}
          onClick={() => onPlatformSelect(platform.id)}
          aria-label={`${platform.name} (${platform.count})`}
          title={platform.name}
        >
          <div className="platform-icon__content">
            {platform.icon}
            {platform.count > 0 && (
              <span className="platform-icon__badge">
                {platform.count > 99 ? '99+' : platform.count}
              </span>
            )}
          </div>
        </button>
      ))}
    </div>
  );
};

export default PlatformSidebar;
